import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Pays } from 'src/app/entity/prospect';
import paysJson from './pays.json';

@Component({
  selector: 'app-country-dialog',
  templateUrl: './country-dialog.component.html',
  styleUrls: ['./country-dialog.component.css']
})
export class CountryDialogComponent implements OnInit,OnChanges {
  pays:Pays[]=paysJson
 
  @Output() select: EventEmitter<Pays> = new EventEmitter<Pays>();
  @Input() visibleCountry:boolean;
  sectedCountry: Pays;
 
  constructor() { }

  ngOnInit(): void {
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.sectedCountry=null;
    
  }
  selectPays(sectedCountry:Pays){
    this.sectedCountry=sectedCountry;
    this.visibleCountry=false;


  }
  hide(){
    this.select.emit(this.sectedCountry)
  }

}
